import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';


// Ce fichier fait le pont entre ton code React (App.tsx) 
// et la page HTML (index.html) que nous venons de créer.
const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
export interface School {
    id: string;
    adminEmail?: string;
    schoolName?: string;
    latitude?: number;
    longitude?: number;
}